import React from "react";

const CustomTableGrid = React.lazy(() =>
  import(/* webpackChunkName: "CustomTableGridV2" */ "./CustomTableGrid")
);

export const CustomTable = (props) => <CustomTableGrid {...props} />;
